import qs from 'query-string'

import root from '~/reducers/utils'
import {store} from '~/stores'
import {commonAxios, req} from '~/utils'

export const LOG_TYPE = {
  home: {
    label: 'H5曝光',
    action: 'expose',
    otype: 'fission',
    src: 'fission',
  },
  invite: {
    label: '立即邀请按钮',
    action: 'click',
    otype: 'fission',
    src: 'share',
  },
  copy: {
    label: '复制口令按钮',
    action: 'click',
    otype: 'fission',
    src: 'copy',
  },
  share: {
    label: '分享到微信',
    action: 'share',
    otype: 'fission',
    src: 'wechat',
  },
}

export type LogType = {
  action: string // type
  otype: string // stype
  src: string // frominfo
  data?: Record<string, any>
}

const createLogId = (() => {
  let id = 0
  return () => {
    id += 1
    return `${Math.floor(Date.now() / 1000)}_${id}`
  }
})()

export function logStat(...args) {
  const search = qs.parse(window.location.search)
  const [arg1, arg2] = args
  const {type, stype, frominfo, action} = arg1
  const userId = localStorage.getItem('userId') || 0
  const did = localStorage.getItem('uuid')
  const params = {
    ...search,
    app: 'pengpeng',
    userId: Number(userId),
    did,
    userAgent: navigator.userAgent,
    type,
    stype,
    frominfo,
    action,
    extdata: {...search, ...arg2},
    timestamp: createLogId(),
  }
  return commonAxios({
    path: '/xai_action_log',
    body: params,
    sign: false,
    root,
  })
}

export function actionStat(...args) {
  // 嵌入客户端h5页面给后端发送埋点记录
  const [arg1, arg2] = args
  const {action, otype, src} = arg1
  const params = {
    list: [
      {
        action,
        otype,
        src,
        data: {
          ...arg2,
          logId: createLogId(),
          isreg: store.getState().deviceInfo?.isreg,
        },
      },
    ],
    from: 'h5',
  }

  return req('/stat/action', params, store, false, null)
}
